import React from 'react';
import { useStore } from 'effector-react';
import { TemplateId } from '@types';
import { $templateId } from '@stores/dataStores';
import { CustomButtonWidget } from './CustomButtonWidget';
import TourTipWidget from './TourTipWidget';
import CategoryWidget from './CategoryWidget';
import TemplateWidgets from '../TemplateWidgets';

function BasicWidgets() {
  // 工程模板单独处理
  const templateId = useStore($templateId);
  return (
    <>
      {templateId !== TemplateId.project &&
        templateId !== TemplateId.metaverseA && <CustomButtonWidget />}
      {templateId !== TemplateId.project && <CategoryWidget />}
      <TourTipWidget />
      <TemplateWidgets />
    </>
  );
}

export default BasicWidgets;
